import { render, staticRenderFns } from "./PageClassification.vue?vue&type=template&id=3a7881b4"
import script from "./PageClassification.vue?vue&type=script&lang=js"
export * from "./PageClassification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports